<div class="animated fadeIn">
  <app-progress-bar [progressValue]="progressValue"> </app-progress-bar>

  <app-category-title
    [title]="categoryTitle"
    [subtitle]="categorySubtitle"
    [stepNumber]="stepNumber"
    [totalSteps]="totalSteps"
  >
  </app-category-title>

  <form
    autocomplete="off"
    [formGroup]="form"
    appInvalidControlScroll
    controlClass="app-question"
    class="main"
  >
    <div
      class="form-group"
      *ngFor="let question of currentQuestions; let i = index"
      formArrayName="categoryQuestions"
    >
      <app-question
        [description]="currentQuestions[i].legend"
        [options]="currentOptions[i]"
        [invalidAnswer]="getInvalidAnswer(i)"
        [formControlName]="i"
      >
      </app-question>

      <small *ngIf="getInvalidAnswer(i)" class="text-danger">
        <span>Marque una opcion</span>
      </small>
    </div>
    <div class="form-group my-3">
      <app-observation-box label="Observaciones" formControlName="observation">
      </app-observation-box>
    </div>

    <div class="form-group my-3 d-flex justify-content-center">
      <app-custom-button
        label="Volver"
        button_style="simple"
        (click)="handleBackClick()"
        class="mr-5"
      >
      </app-custom-button>
      <app-custom-button
        label="Siguiente"
        button_style="outline"
        (click)="saveChanges()"
      >
      </app-custom-button>
    </div>
  </form>
</div>
